export default Object.freeze({
    font: {
        // standard text sizes:
        xs: 12,
        sm: 14,
        md: 16,
        lg: 18,
        xl: 22, // used for 'regular' size text
        // used for display/headers sizes
        '2xl': 24,
        '3xl': 30,
        '4xl': 36,
        '5xl': 48
    },
    /**
     * Corner radius guidelines for cards, buttons, inputs, etc.
     * Values represented are pixel dimensions.
     */
    radius: {
        /** No Rounding (0px) */
        none: 0,
        /** 2px */
        xxs: 2,
        /** 4px */
        xs: 4,
        /** 6px */
        sm: 6,
        /** 8px */
        md: 8,
        /** 10px */
        lg: 10,
        /** 12px */
        xl: 12,
        /** 16px */
        '2xl': 16,
        /** 20px */
        '3xl': 20,
        /** 24px */
        '4xl': 24,

        full: 9999
    },
    /**
     *  Used for the sidebar and utility nav
     */
    fixedSpacing: {
        /** No spacing (0px) */
        none: 0,
        /** 2px */
        xxs: 2,
        /** 4px */
        xs: 4,
        /** 6px */
        sm: 6,
        /** 8px */
        md: 8,
        /** 12px */
        lg: 12,
        /** 16px */
        xl: 16,
        /** 20px */
        '2xl': 20,
        /** 24px */
        '3xl': 24,
        /** 32px */
        '4xl': 32,
        /** 40px */
        '5xl': 40,
        /** 48px */
        '6xl': 48,
        /** 64px */
        '7xl': 64,
        /** 80px */
        '8xl': 80,
        /** 96px */
        '9xl': 96,
        /** 128px */
        '10xl': 128,
        /** 160px */
        '11xl': 160
    },
    /**
     * Spacing guidelines represent padding + margin.
     * Values are based on a 12-column grid for desktop and a 5-column grid for mobile
     * that adapts responsively across different breakpoints.
     * design-grid columns are separated by consistent gutters using roughly 1.67% viewport units (1.67vw) on desktop
     * and 4% on mobile. the SideBar is ignored in this calculation.
     * Spacing ramp is based on an 8-point grid with 4px representing 1rem at 1440px width.
     */
    getAdaptiveSpacing: ({ width, mobile }) => {
        return {
            none: 0,
            /** 2px */
            xxs: mobile ? Math.round(width * 0.0051) : Math.round(width * 0.0014),
            /** 4px */
            xs: mobile ? Math.round(width * 0.0102) : Math.round(width * 0.0028),
            /** 6px */
            sm: mobile ? Math.round(width * 0.0153) : Math.round(width * 0.0042),
            /** 8px */
            md: mobile ? Math.round(width * 0.0204) : Math.round(width * 0.0056),
            /** 12px */
            lg: mobile ? Math.round(width * 0.0254) : Math.round(width * 0.0069),
            /** 16px */
            xl: mobile ? Math.round(width * 0.0407) : Math.round(width * 0.0083),
            /** 20px*/
            '2xl': mobile ? Math.round(width * 0.0509) : Math.round(width * 0.0139),
            /** 24px */
            '3xl': mobile ? Math.round(width * 0.0611) : Math.round(width * 0.0167),
            /** 32px */
            '4xl': mobile ? Math.round(width * 0.0814) : Math.round(width * 0.0222),
            /** 40px */
            '5xl': mobile ? Math.round(width * 0.1018) : Math.round(width * 0.0278),
            /** 48px */
            '6xl': mobile ? Math.round(width * 0.1221) : Math.round(width * 0.0333),
            /** 64px */
            '7xl': mobile ? Math.round(width * 0.1628) : Math.round(width * 0.0444),
            /** 80px */
            '8xl': mobile ? Math.round(width * 0.2036) : Math.round(width * 0.0556),
            /** 96px */
            '9xl': mobile ? Math.round(width * 0.2443) : Math.round(width * 0.0667),
            /** 128px */
            '10xl': mobile ? Math.round(width * 0.3257) : Math.round(width * 0.0889),
            /** 160px */
            '11xl': mobile ? Math.round(width * 0.4071) : Math.round(width * 0.1111)
        };
    }
});
